import React, { useEffect, useState } from "react";
import Layout from "../../components/layout";
import { FaArrowLeft, FaSearch, FaCalendarAlt } from "react-icons/fa";

import styles from "./OrdersPage.module.scss";
import { useNavigate } from "react-router-dom";
import { route } from "../../static/route";
import Select from "react-select";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  fetchItemsList,
  fetchOrdersListData,
  fetchProcessesList,
  getItems,
  getOrders,
  getParties,
  getProcesses,
  getTotalOrders,
  fetchPartiesList,
  getIsOrderModalOpen,
  getEditOrder,
  setEditOrder,
  getTotalAmount,
  getIsOrderPhotoModalOpen,
} from "../../features/orders/ordersSlice";
import Pagination from "../../components/pagination";
import { toast } from "react-toastify";
import { selectStyles, toastStyles } from "../../static/styles";
import { DELETE, GET, PUT } from "../../services/axios.service";
import { Controller, useForm } from "react-hook-form";
import OrderList from "../../components/orders/OrderList";
import { IFormInput, OptionsProps } from "../../types/orders";
import OrdersFormModal from "../../components/orders/OrdersFormModal";
import PhotoModel from "../../components/orders/PhotoModel";
import moment from "moment";

const OrdersPage = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME_GU;

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const orders = useAppSelector(getOrders);
  const totalOrders = useAppSelector(getTotalOrders);
  const totalAmount = useAppSelector(getTotalAmount);
  const items = useAppSelector(getItems);
  const processes = useAppSelector(getProcesses);
  const parties = useAppSelector(getParties);
  const isOrderModalOpen = useAppSelector(getIsOrderModalOpen);
  const editOrder = useAppSelector(getEditOrder);
  const isOrderPhotoModalOpen = useAppSelector(getIsOrderPhotoModalOpen);

  const [itemOption, setItemOption] = useState<OptionsProps[]>([]);
  const [processOption, setProcessOption] = useState<OptionsProps[]>([]);
  const [partyOption, setPartyOption] = useState<OptionsProps[]>([]);
  const [statusOption] = useState<OptionsProps[]>([
    {
      value: 0,
      label: "ચાલુ કામ",
    },
    {
      value: 1,
      label: "પૂરું થયેલું કામ",
    },
  ]);
  const [typeOption] = useState<OptionsProps[]>([
    {
      value: 0,
      label: "કામ ના આધારે",
    },
    {
      value: 1,
      label: "પાર્ટી ના આધારે",
    },
  ]);

  interface FilterFormInput {
    name: string;
    fromDate: string;
    toDate: string;
    party_id: number;
    item_id: number;
    process_id: number;
    status: number;
  }

  interface ExportFormInput {
    fromDate: string;
    toDate: string;
    party_id: number;
    type: number;
  }

  const { handleSubmit, register, reset, getValues, control, setValue } =
    useForm<FilterFormInput>();

  const {
    handleSubmit: handleSubmit1,
    register: register1,
    reset: reset1,
    control: control1,
    setValue: setValue1,
  } = useForm<ExportFormInput>();

  const [page, setPage] = useState<number>(1);
  const [pageSize] = useState<number>(50);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showExport, setShowExport] = useState(false);

  const hanldeGoToHome = () => {
    navigate(route.dashboard);
  };

  const paginate = (pageNumber: number) => {
    setPage(pageNumber);
  };

  const handleDeleteOrder = async (id: number, password: string) => {
    try {
      await DELETE(`/v1/admin/orders/${id}`, {
        password: password,
      })
        .then(async (response: any) => {
          if (response.data.status === "success") {
            const pageNumber = orders.length > 1 ? page : page - 1;
            if (page === pageNumber) {
              fetchOrdersList(page, pageSize);
            } else {
              setPage(pageNumber);
            }

            toast.success(response.data.message, {
              ...(toastStyles as any),
            });
          } else {
            toast.error(response.data.message, {
              ...(toastStyles as any),
            });
          }
        })
        .catch((error: any) => {
          toast.error(error.data.message, {
            ...(toastStyles as any),
          });
        });
    } catch (error) {
      toast.error("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.", {
        ...(toastStyles as any),
      });
    }
  };

  const handleOnFilterSubmit = async () => {
    fetchOrdersList(page, pageSize);
  };

  const handleOnExportSubmit = async (data: ExportFormInput) => {
    try {
      await GET(`/v1/admin/reports`, {
        fromDate: data.fromDate,
        toDate: data.toDate,
        party_id: data.party_id,
        type: data.type,
      })
        .then(async (response: any) => {
          if (response.data.status === "success") {
            toast.success(response.data.message, {
              ...(toastStyles as any),
            });

            const downloadLink = response.data.data.download_link;
            try {
              const newWindow = window.open(downloadLink, "_blank");
              if (
                !newWindow ||
                newWindow.closed ||
                typeof newWindow.closed == "undefined"
              ) {
                throw new Error("Pop-up blocked");
              }
            } catch (e) {
              window.location.href = downloadLink;
            }
          } else {
            toast.error(response.data.message, {
              ...(toastStyles as any),
            });
          }
        })
        .catch((error: any) => {
          toast.error(error.data.message, {
            ...(toastStyles as any),
          });
        });
    } catch (error) {
      toast.error("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.", {
        ...(toastStyles as any),
      });
    }
  };

  const handleClearFilter = () => {
    reset();
    fetchOrdersList(page, pageSize);
  };

  const handleClearExport = () => {
    reset1();
  };

  const fetchOrdersList = async (page: number, size: number) => {
    const data = getValues();

    setIsLoading(true);

    dispatch(
      fetchOrdersListData({
        page: page,
        size: size,
        search: data?.name || null,
        fromDate: data?.fromDate || null,
        toDate: data?.toDate || null,
        party_id: data?.party_id || null,
        item_id: data?.item_id || null,
        process_id: data?.process_id || null,
        status: data?.status || data?.status === 0 ? data?.status : null,
      })
    ).then(() => {
      setIsLoading(false);
    });
  };

  const handleSaveOrder = async (data: IFormInput) => {
    try {
      if (editOrder) {
        await PUT(`/v1/admin/orders/${editOrder.id}`, {
          item_id: data.item_id,
          process_id: data.process_id,
          qty: data.qty,
          delivered_qty: data.delivered_qty,
          status: data.status || 0,
          rate: data.rate,
          created_at: moment(data.created_at).format("YYYY-MM-DD H:mm:ss"),
          inch: data.inch || 0,
        })
          .then(async (response: any) => {
            if (response.data.status === "success") {
              await dispatch(setEditOrder(null));

              fetchOrdersList(page, pageSize);

              toast.success(response.data.message, {
                ...(toastStyles as any),
              });
            } else {
              toast.error(response.data.message, {
                ...(toastStyles as any),
              });
            }
          })
          .catch((error: any) => {
            toast.error(error.data.message, {
              ...(toastStyles as any),
            });
          });
      }
    } catch (error) {
      toast.error("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.", {
        ...(toastStyles as any),
      });
    }
  };

  useEffect(() => {
    fetchOrdersList(page, pageSize);
  }, [page]);

  useEffect(() => {
    const options =
      items?.map((item) => ({ value: item.id, label: item.name })) ?? [];
    setItemOption(options);
  }, [items]);

  useEffect(() => {
    const options =
      processes?.map((process) => ({
        value: process.id,
        label: process.name,
      })) ?? [];
    setProcessOption(options);
  }, [processes]);

  useEffect(() => {
    const options =
      parties?.map((party) => ({ value: party.id, label: party.firm_name })) ??
      [];
    setPartyOption(options);
  }, [parties]);

  useEffect(() => {
    dispatch(fetchItemsList());
    dispatch(fetchProcessesList());
    dispatch(fetchPartiesList());
  }, []);

  return (
    <Layout>
      <div className={styles.OrdersPage}>
        <div className="logoSection">
          <h1
            onClick={hanldeGoToHome}
            className="text-5xl font-bold text-white lg:text-3xl cursor-pointer lg:w-fit"
          >
            {companyName}
          </h1>

          <hr className="w-[180px] border-white border-[4px] rounded-[4px] mx-auto mt-4 lg:mx-0 lg:w-24 lg:border-[2px] lg:mt-2" />
        </div>

        <div className="pageTitleSection">
          <FaArrowLeft
            onClick={hanldeGoToHome}
            className="lg:hidden absolute top-5 left-5 text-3xl text-white border-2 border-white p-1 rounded-full"
          />

          <h1 className="text-5xl mt-6 lg:mt-0 font-bold text-white lg:text-2xl lg:text-primary-1">
            ઓર્ડર ની વિગતો
          </h1>
        </div>

        <div className="mt-[60px] px-10 py-5">
          <div className="flex justify-between gap-4 items-center mb-4">
            <p className="text-primary-1 font-bold mt-auto">
              ટોટલ અમાઉન્ટ: {totalAmount.toFixed(2) || 0.0}
            </p>

            <div className="grid lg:flex gap-4">
              <button
                className="p-2 rounded-md flex items-center bg-gradient-to-r from-primary-1 to-primary-2 text-white transition-colors duration-300"
                onClick={() => {
                  if (!showExport === true) setShowFilter(false);
                  setShowExport(!showExport);
                }}
              >
                <FaSearch className="mr-2" />{" "}
                {showExport ? "રિપોર્ટ છુપાવો" : "રિપોર્ટ બતાવો"}
              </button>

              <button
                className="p-2 rounded-md flex items-center bg-gradient-to-r from-primary-1 to-primary-2 text-white transition-colors duration-300"
                onClick={() => {
                  if (!showFilter === true) setShowExport(false);
                  setShowFilter(!showFilter);
                }}
              >
                <FaSearch className="mr-2" />{" "}
                {showFilter ? "ફિલ્ટર છુપાવો" : "ફિલ્ટર બતાવો"}
              </button>
            </div>
          </div>

          {showFilter && (
            <form onSubmit={handleSubmit(handleOnFilterSubmit)}>
              <div className="mb-4 bg-white shadow rounded p-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]">
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1 placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px]"
                      type="date"
                      {...register("fromDate")}
                      placeholder="From Date"
                    />
                  </div>

                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]">
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1  placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px]"
                      type="date"
                      {...register("toDate")}
                      placeholder="To Date"
                    />
                  </div>

                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded p-[2px] h-[44px]">
                    <input
                      {...register("name")}
                      className="text-primary-1 px-3 py-1 font-semibold text-xl placeholder:text-primary-2 w-full h-full rounded focus:outline-none"
                      placeholder="ઓર્ડર ID દ્વારા શોધો"
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-12 w-full relative rounded">
                    <Controller
                      {...register("party_id")}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            partyOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"પાર્ટી નું નામ સિલેક્ટ કરો"}
                          options={partyOption}
                          onChange={(val: any) =>
                            setValue("party_id", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-12 w-full relative rounded">
                    <Controller
                      {...register("item_id")}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            itemOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"આઈટમ નું નામ સિલેક્ટ કરો"}
                          options={itemOption}
                          onChange={(val: any) =>
                            setValue("item_id", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-12 w-full relative rounded">
                    <Controller
                      {...register("process_id")}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            processOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"પ્રોસેસ નું નામ સિલેક્ટ કરો"}
                          options={processOption}
                          onChange={(val: any) =>
                            setValue("process_id", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-12 w-full relative rounded">
                    <Controller
                      {...register("status")}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            statusOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"સ્ટેટ્સ નું નામ સિલેક્ટ કરો"}
                          options={statusOption}
                          onChange={(val: any) =>
                            setValue("status", val?.value)
                          }
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-end mt-4">
                  <button
                    onClick={handleClearFilter}
                    type="button"
                    className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                  >
                    હટાઓ
                  </button>

                  <button
                    type="submit"
                    className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                  >
                    ફિલ્ટર લાગુ કરો
                  </button>
                </div>
              </div>
            </form>
          )}

          {showExport && (
            <form onSubmit={handleSubmit1(handleOnExportSubmit)}>
              <div className="mb-4 bg-white shadow rounded p-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]">
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1 placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px]"
                      type="date"
                      {...register1("fromDate")}
                      placeholder="From Date"
                    />
                  </div>

                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]">
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1  placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px]"
                      type="date"
                      {...register1("toDate")}
                      placeholder="To Date"
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-11 w-full relative rounded">
                    <Controller
                      {...register1("party_id")}
                      control={control1}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            partyOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"પાર્ટી નું નામ સિલેક્ટ કરો"}
                          options={partyOption}
                          onChange={(val: any) =>
                            setValue1("party_id", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-11 w-full relative rounded">
                    <Controller
                      {...register1("type")}
                      control={control1}
                      defaultValue={0}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            typeOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"ટાઈપ સિલેક્ટ કરો"}
                          options={typeOption}
                          onChange={(val: any) => setValue1("type", val?.value)}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-end mt-4">
                  <button
                    onClick={handleClearExport}
                    type="button"
                    className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                  >
                    હટાઓ
                  </button>

                  <button
                    type="submit"
                    className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                  >
                    રિપોર્ટ બનાવો
                  </button>
                </div>
              </div>
            </form>
          )}

          <OrderList
            orders={orders}
            pageNumber={page}
            pageSize={pageSize}
            isLoading={isLoading}
            handleDeleteOrder={handleDeleteOrder}
          />

          <Pagination
            itemsPerPage={pageSize}
            totalItems={totalOrders}
            paginate={paginate}
            currentPage={page}
          />

          {isOrderModalOpen === true && (
            <OrdersFormModal handleSaveOrder={handleSaveOrder} />
          )}

          {isOrderPhotoModalOpen !== null && <PhotoModel />}
        </div>
      </div>
    </Layout>
  );
};
export default OrdersPage;
